import React, { Component } from "react"
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps"

import * as d3 from 'd3';
import CircularProgress from '@material-ui/core/CircularProgress'
import WarningIcon from '@material-ui/icons/Warning';

//import ReactTooltip from "react-tooltip"
import ToolTip from "react-portal-tooltip"

import MapLegend from '../components/mapLegend'
import MapOffshoreIcon from '../components/mapOffshoreIcon'
//import HoverInfo from '../components/obsolete_HoverInfo'

const styles = theme => ({
  toolTip: {
    opacity: '1!important',
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '10pt!important',
    //minWidth:'280px',
    color: 'black!important',
  },
  leftTableColumn: {
    //width: '75%',
    width: '230px',
    textAlign: 'left',
    fontSize: '10pt!important',
  },
  rightTableColumn: {
    //width: '25%',
    textAlign: 'right',
    fontFamily: 'Nunito Sans Bold!important',
    fontSize: '10pt!important',
  },
  tableHeader: {
    fontFamily: 'Nunito Sans Bold!important',
  },
  wrapperStyles: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      //width: '550px',
      width: '100%',
    },
    //width:'100%',
    maxWidth: '820px',
    //marginLeft: "0",
    margin: "0 auto",
    //backgroundColor:'#f3f3f3', 
  },
  tooltipCloseRow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  tooltipCloseButton: {
    cursor: "pointer",
    padding: "10px 0px 5px 10px",
  },
  limitedFunctionalityWarning: {
    fontSize: '12pt',
    color: '#f77!important',
    fontFamily: 'Nunito Sans Regular!important',
    textAlign: 'center',
    width: '100%',
  },
});


let isIE = /*@cc_on!@*/false || !!document.documentMode;
let mobileCheck = false;
window.mobileCheck = function () {
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobileCheck = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return mobileCheck;
};

let tooltipStyle = {
  style: {
    background: 'rgba(219,219,219,1)',    
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    boxShadow: '3px 3px 2px rgba(0,0,0,.5)',

    fontFamily: 'Nunito Sans Regular',
    fontSize: '10pt',
    color: 'black!important',
  },
  arrowStyle: {
    color: 'rgba(128,128,128,1)',
    borderColor: false
  }
}

class EnergyMapWallonie extends Component {
  constructor() {
    super()

    this.state = {
      populationData: true,
      valueScale: d3.scaleLinear().clamp(true),
      colorScale: d3.scaleLinear().interpolate(d3.interpolateRgb),
      unitHour: 'Wh',
      unitMonth: 'Wh',
      //format: d3.format('~s'),
      componentUpdated: false,
      dataReady: false,
      currentTech: {
        solar: true,
        wind: false,
        windOffshore: false,
      },
      currentFilter: 'energy',
      currentMode: 'realtime',
      hasForecast: false,

      //height: 512,
      //windowWidth: 1200,

      isTooltipActive: {},
      allTooltipsFalse: {},
    }

    this.updateMapData = this.updateMapData.bind(this)
    this.showTooltip = this.showTooltip.bind(this)
    this.removeTooltips = this.removeTooltips.bind(this)
  }

  showTooltip = (e) => {
    //const target = e.properties.NISCODE_ge
    const target = parseInt(e.currentTarget.attributes.municipalityid.value)
    //console.log(target);

    this.setState(() => {
      let isTooltipActive = { ...this.state.allTooltipsFalse }
      isTooltipActive[target] = true
      return {
        isTooltipActive: isTooltipActive
      }
    });
  }

  removeTooltips() {
    console.log("removeTooltips")
    this.setState((previousState) => {
      return {
        isTooltipActive: { ...previousState.allTooltipsFalse }
      }
    });
  }

  //componentDidMount() {
  //  setTimeout(() => {
  //    ReactTooltip.rebuild()
  //  }, 1500)
  //}

  componentDidUpdate() {
    if (this.props.dataReady) {
      if (!this.state.componentUpdated) {
        this.updateMapData()
      }
      else {
        let stateupdated = (
          JSON.stringify(this.props.currentTech) === JSON.stringify(this.state.currentTech)
          && this.props.currentFilter === this.state.currentFilter
          && this.props.currentMode === this.state.currentMode
          && this.props.currentDateTime === this.state.currentDateTime

          //&& this.props.windowWidth === this.state.windowWidth
        )
        if (!stateupdated || !this.state.componentUpdated) {
          this.updateMapData()
        }
      }
      //setTimeout(() => {
      //  ReactTooltip.rebuild()
      //}, 100)
    }
    else {
      if (this.state.componentUpdated) {
        this.setState({ componentUpdated: false });
      }
    }
  }

  updateMapData() {
    let valueScale = this.state.valueScale
    let colorArray = this.props.colorArray
    let colorScale = this.state.colorScale
    let unitHour = this.state.unitHour
    let unitMonth = this.state.unitMonth

    // map js color function
    //let colorScaleLength = colorArray.length
    valueScale.range([0, colorArray.length - 1])
    colorScale.range(colorArray.map(function (hex) {
      let c = d3.color(hex)
      //c.opacity=0.5
      return c
    }));
    colorScale.domain([...Array(colorArray.length).keys()].map(valueScale.invert))

    let inw
    switch (this.props.lang) {
      case "de":
        inw = "einw"
        break;
      case "en":
        inw = "inh"
        break;
      case "fr":
      default:
        inw = "hab"
    }

    switch (this.props.currentFilter) {
      case 'inhabitants':
        unitHour = 'Wh/' + inw;
        unitMonth = 'kWh/' + inw;
        break;
      case 'surface':
        unitHour = 'MWh/km²';
        unitMonth = 'GWh/km²';
        break;
      default:
      case 'energy':
        unitHour = 'MWh';
        unitMonth = 'GWh';
    }

    const actualDate = new Date();
    const currentSelectedDate = new Date(this.props.currentDateTime)
    const hasForecast = (currentSelectedDate.toDateString() === actualDate.toDateString() || currentSelectedDate.getTime() > actualDate.getTime())

    valueScale.domain([0, d3.max(this.props.data, function (t) { return d3.max(Object.keys(t.values).map(key => t.values[key])) })]).nice()
    colorScale.domain([...Array(colorScale.domain().length).keys()].map(valueScale.invert))

    this.setState((previousState, props) => {
      let isTooltipActive = { ...previousState.isTooltipActive }
      let allTooltipsFalse = { ...previousState.allTooltipsFalse }
      if (Object.keys(isTooltipActive).length === 0 && isTooltipActive.constructor === Object) {
        this.props.wallonie.objects.RW_Communes.geometries.map(geography => {
          isTooltipActive[geography.properties.OBJECTID] = false;
          return false
        });
        allTooltipsFalse = isTooltipActive;
      }


      return {
        colorScale: colorScale,
        valueScale: valueScale,
        data: this.props.data,
        unitHour: unitHour,
        unitMonth: unitMonth,
        componentUpdated: true,
        currentDateTime: this.props.currentDateTime,
        dataReady: true,
        currentTech: this.props.currentTech,
        currentFilter: this.props.currentFilter,
        currentMode: this.props.currentMode,
        hasForecast: hasForecast,

        isTooltipActive: isTooltipActive,
        allTooltipsFalse: allTooltipsFalse,
      }
    });
  }

  render() {
    const { classes } = this.props;

    if (!this.props.dataReady || !this.state.dataReady || !this.state.componentUpdated) {
      return (<div className={classes.chartDiv}>
        <CircularProgress className={classes.progress} size={50} />
      </div>)
    }

    let currentData

    let currentDateTime = this.props.currentDateTime
    currentData = this.state.data.filter(function (v) {
      return (v.datetime.getTime() === new Date(currentDateTime).getTime())
    })[0].values

    //let reactToolTips
    const hasForecast = this.state.hasForecast
    const installedCapacities = this.props.capacities
    const dayProductions = this.props.dayProductions
    const uncutDayProductions = this.props.uncutDayProductions
    const currentFilter = this.props.currentFilter
    const currentMode = this.props.currentMode
    const co2AvoidedFactor = this.props.co2AvoidedFactor

    const currentYear = parseInt(d3.timeFormat('%Y')(new Date()))
    const energyUsePerFamily = (this.props.currentMode === 'realtime' ? 9.589 : (this.props.yearSelected === currentYear ? (3500 * this.props.data.length / 12) : 3500))
    //const energyUsePerFamily = 9.589

    let limitedFunctionalityWarning
    switch (this.props.lang) {
      case "de":
        limitedFunctionalityWarning = "Internet Explorer ondersteunt niet alle mogelijkheden. Gebruik een andere browser voor een optimale ervaring."
        break
      case "en":
        limitedFunctionalityWarning = "Internet Explorer does not support all options. Use another browser for an optimal experience."
        break
      case "fr":
      default:
        limitedFunctionalityWarning = "Internet Explorer ne prend pas en charge toutes les options. Utilisez un autre navigateur pour une expérience optimale."
    }

    let inLabel
    let productionLastHour
    let productionLastMonth
    let expectedProductionWholeDay
    let productionWholeDay
    let productionWholeYear
    switch (this.props.lang) {
      case "de":
        inLabel = 'in '
        productionLastHour = 'Productie afgelopen uur'
        productionLastMonth = 'Productie afgelopen maand'
        expectedProductionWholeDay = 'Verwachte productie volledige dag'
        productionWholeDay = 'Productie volledige dag'
        productionWholeYear = 'Productie volledige year'
        break;
      case "en":
        inLabel = 'in '
        productionLastHour = 'Production last hour'
        productionLastMonth = 'Production last month'
        expectedProductionWholeDay = 'Expected production whole day'
        productionWholeDay = 'Production whole day'
        productionWholeYear = 'Production whole year'
        break;
      case "fr":
      default:
        inLabel = 'in '
        productionLastHour = 'Production dernière heure'
        productionLastMonth = 'Production dernier mois'
        expectedProductionWholeDay = 'Production attendue journée complète'
        productionWholeDay = 'Production journée complète'
        productionWholeYear = 'Production année complète'
    }

    const labelProductionLastHourMonth = currentMode === 'realtime' ?
      (productionLastHour + ' (' + inLabel + this.state.unitHour + ')') :
      (productionLastMonth + ' (' + inLabel + this.state.unitMonth + ')')

    const labelProductionDayYear = currentMode === 'realtime' ?
      (hasForecast ?
        (expectedProductionWholeDay + ' (' + inLabel + this.state.unitHour + ")")
        : (productionWholeDay + ' (' + inLabel + this.state.unitHour + ")")
      ) :
      (productionWholeYear + ' (' + inLabel + this.state.unitMonth + ")")

    const unitHour = this.state.unitHour
    const unitMonth = this.state.unitMonth

    const lang = this.props.lang
    let municipalityLabel

    let inhabitantAbbreviation
    let renewableEnergy

    let perHour
    let perDay
    let predictedForDay


    let perMonth
    let perYear
    let predictedForYear

    let productionLastHourLabel
    let dayProductionLabel
    let expectedDayProductionLabel

    let productionLastMonthLabel
    let monthProductionLabel
    let expectedMonthProductionLabel

    let familiesProvidedLabel
    let powerLabel
    let co2AvoidedLabel

    if (currentData !== undefined) {
      let geoData = this.props.wallonie

      if (!isIE || !this.props.isPlaying) {
        switch (lang) {
          case "de":
            municipalityLabel = "Gemeinde"

            inhabitantAbbreviation = "Einw"
            renewableEnergy = 'Ernuerbare Produktion'

            perHour = 'pro Stunde'
            perDay = 'für den Tag'
            predictedForDay = 'für den Tag geplant'

            //productionLastHourLabel = "Productie afgelopen uur (in "
            //dayProductionLabel = "Productie volledige dag (in "
            //expectedDayProductionLabel = "Verwachte productie volledige dag (in"

            perMonth = 'pro Monat'
            perYear = 'für das Jahr'
            predictedForYear = 'für das Jahr geplant'

            productionLastMonthLabel = "Productie afgelopen maand (in "
            monthProductionLabel = "Productie volledige dag (in "
            expectedMonthProductionLabel = "Verwachte productie volledige dag (in"

            familiesProvidedLabel = "Anzahl der belieferten Haushalte (Tausende)"
            powerLabel = "Installierte Leistung (MW)"
            co2AvoidedLabel = "CO\u2082 vermieden (Tonne)"
            break
          case "en":
            municipalityLabel = "Municipality"

            inhabitantAbbreviation = "inh"
            renewableEnergy = 'Production from renewables'

            perHour = 'per hour'
            perDay = 'for the day'
            predictedForDay = 'forecasted for the day'

            //productionLastHourLabel = "Production last hour (in "
            //dayProductionLabel = "Production whole day (in "
            //expectedDayProductionLabel = "Expected production whole day (in"

            perMonth = 'per month'
            perYear = 'for the year'
            predictedForYear = 'forecasted for the Year'

            productionLastMonthLabel = "Production last month (in "
            monthProductionLabel = "Production whole month (in "
            expectedMonthProductionLabel = "Expected production whole month (in"

            familiesProvidedLabel = "Number of provided households (thousands)"
            powerLabel = "Installed power (MW)"
            co2AvoidedLabel = "CO\u2082 avoided (ton)"
            break
          case "fr":
          default:
            municipalityLabel = "Commune"

            inhabitantAbbreviation = "hab"
            renewableEnergy = 'Production renouvelable'

            perHour = 'par heure'
            perDay = 'pour la journée'
            predictedForDay = 'prévue pour la journée'

            //productionLastHourLabel = "Production dernière heure (en "
            //dayProductionLabel = "Production journée complète (en "
            //expectedDayProductionLabel = "Production prévue toute la journée (en "

            perMonth = 'par mois'
            perYear = 'pour l\'année'
            predictedForYear = 'prévue pour l\'année'

            productionLastMonthLabel = "Production dernier mois (en "
            monthProductionLabel = "Production mois complet (en "
            expectedMonthProductionLabel = "Production prévue tout le mois (en "

            familiesProvidedLabel = "Nombre de foyers fournis (milliers)"
            powerLabel = "Puissance installée (MW)"
            co2AvoidedLabel = "CO\u2082 évité (ton)"
        }
        /*
        if (currentData !== undefined) {
          reactToolTips = geoData.objects.RW_Communes.geometries.map(function (geography) {
            const municipalityID = (String)(geography.properties.ADMUKEY)
            const recordID = (String)(geography.properties.OBJECTID)
            let municipalityName
            const productionLastHour = currentData[geography.properties.ADMUKEY]
            const dayProduction = dayProductions[geography.properties.ADMUKEY]
            const uncutDayProduction = uncutDayProductions[geography.properties.ADMUKEY]
            const installedCapacity = installedCapacities[geography.properties.ADMUKEY]
            const co2Avoided = co2AvoidedFactor * dayProductions[geography.properties.ADMUKEY]

            switch (lang) {
              case "de":
                municipalityName = geography.properties.NAMEGER
                break
              case "en":
                municipalityName = geography.properties.NAMEFRE
                break
              case "fr":
              default:
                municipalityName = geography.properties.NAMEFRE
            }


            return (
              <ReactTooltip id={recordID} key={recordID} className={classes.toolTip + ' bgmediumgrey'}>
                <table style={{ minWidth: '300px' }}>
                  <tbody>
                    <tr>
                      <td className={classes.leftTableColumn}>{municipalityLabel}</td>
                      <td className={classes.rightTableColumn}><b>{municipalityName}</b></td>
                    </tr>
                    <tr>
                      <td className={classes.leftTableColumn}>{
                        currentMode === 'realtime' ?
                          (productionLastHourLabel + unitHour + ')')
                          : null
                      }
                      </td>
                      <td className={classes.rightTableColumn}>
                        <b>
                          {
                            isNaN(productionLastHour) ? "0" :
                              (currentMode === 'realtime' ?
                                (currentFilter === 'inhabitants' ?
                                  (productionLastHour * 1000).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                                  : Math.round(productionLastHour).toLocaleString(localeOption)
                                ) : null
                              )
                          }
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.leftTableColumn}>
                        {currentMode === 'realtime' ?
                          (hasForecast ?
                            (expectedDayProductionLabel + unitHour + ")")
                            : (dayProductionLabel + unitHour + ")")
                          ) : null
                        }
                      </td>
                      <td className={classes.rightTableColumn}>
                        <b>
                          {isNaN(dayProduction) ?
                            "0" :
                            (currentMode === 'realtime' ?
                              (currentFilter === 'inhabitants' ?
                                (dayProduction * 1000).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                                : Math.round(dayProduction).toLocaleString(localeOption)
                              ) : null
                            )
                          }
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.leftTableColumn}>{familiesProvidedLabel}</td>
                      <td className={classes.rightTableColumn}><b>{isNaN(uncutDayProduction) ? "0" : Math.round(uncutDayProduction / energyUsePerFamily).toLocaleString(localeOption)}</b></td>
                    </tr>
                    <tr>
                      <td className={classes.leftTableColumn}>{powerLabel}</td>
                      <td className={classes.rightTableColumn}><b>{isNaN(installedCapacity) ? "0" : (Math.round(10 * installedCapacity) / 10).toLocaleString(localeOption)}</b></td>
                    </tr>
                    <tr>
                      <td className={classes.leftTableColumn}>{co2AvoidedLabel}</td>
                      <td className={classes.rightTableColumn}><b>{isNaN(co2Avoided) ? "0" : (Math.round(co2Avoided / 1000).toLocaleString(localeOption))}</b></td>
                    </tr>
                  </tbody>
                </table>
              </ReactTooltip>
            )
          });
        }
        */
      }
    }

    const localeOption = (this.props.lang === "de" ? 'de-DE' : (this.props.lang === "en" ? 'en-GB' : 'fr-BE'))

    let isTooltipActive = this.state.isTooltipActive
    const removeTooltips = this.removeTooltips;

    return (
      <div className={classes.wrapperStyles}>
        {
          this.props.currentTech.windOffshore && <MapOffshoreIcon
            //show={this.props.currentTech.windOffshore}
            currentTech={this.props.currentTech}
            currentMode={this.props.currentMode}
            currentFilter={this.props.currentFilter}
            data={this.props.offshoreData}

            maxValue={this.props.offshoreMaxValue}
            capacity={this.props.offshoreCapacity}
            dayProduction={this.props.offshoreDayProduction}
            currentDateTime={this.props.currentDateTime}
            dataReady={this.props.dataReady}
            colorArray={this.props.colorArray}
            yearSelected={this.props.yearSelected}
            isPlaying={this.props.playing}
            windowWidth={this.props.windowWidth}
            lang={this.props.lang}
            co2AvoidedFactor={this.props.co2AvoidedFactor}
          />
          /*
          <HoverInfo
            lang={this.props.lang}
          />
          */
        }

        <MapLegend
          currentTech={this.props.currentTech}
          currentFilter={this.props.currentFilter}
          currentMode={this.props.currentMode}
          maxValue={this.props.maxValue}
          lang={this.props.lang}
        />
        {
          //<MapLegend />
          //isIE  && this.props.isPlaying && <p className={classes.limitedFunctionalityWarning}><WarningIcon style={{verticalAlign:'middle',marginRight:'10px'}}/>{ limitedFunctionalityWarning }</p>
          isIE && <p className={classes.limitedFunctionalityWarning}><WarningIcon style={{ verticalAlign: 'middle', marginRight: '10px' }} />{limitedFunctionalityWarning}</p>
        }
        {
          (this.state.dataReady ?
            <div style={{ overflow: "hidden" }}>
              <ComposableMap
                projectionConfig={{
                  scale: 11500,
                }}
                height={420}
                //projection={projection}
                projection="geoMercator"
              >
                <ZoomableGroup
                  center={[4.55, 50.15]}
                  //disablePanning
                  zoom={1}
                  minZoom={1}
                  maxZoom={1}
                >
                  <Geographies
                    geography={this.props.provinces}
                  //disableOptimization // should only be removed if there are no updates to the map https://github.com/zcreativelabs/react-simple-maps/blob/master/README.md
                  >
                    {({ geographies }) => geographies.map(geo =>
                      <Geography
                        key={geo.properties.OBJECTID}
                        geography={geo}
                        style={{
                          default: {
                            fill: "rgba(255,255,255,0.1)",
                            stroke: "#000",
                            strokeWidth: 1.5,
                            outline: "none",
                            //outline: "2pt solid red",
                          },
                          hover: {
                            fill: "rgba(0,0,0,0.1)",
                            stroke: "#666",
                            strokeWidth: 0.75,
                            outline: "none",
                          },

                        }}

                      />
                    )}
                  </Geographies>
                  <Geographies
                    geography={this.props.wallonie}
                  //disableOptimization // should only be removed if there are no updates to the map https://github.com/zcreativelabs/react-simple-maps/blob/master/README.md
                  >
                    {({ geographies }) => geographies.map(geo =>
                      <Geography
                        key={geo.properties.OBJECTID}
                        id={"municipality_" + geo.properties.OBJECTID}
                        municipalityid={geo.properties.OBJECTID}
                        //onMouseEnter={this.showTooltip}
                        onClick={this.showTooltip}
                        data-tip={(this.props.lang === "de" ? geo.properties.NAMEGER : geo.properties.NAMEFRE) + " " + currentData[geo.properties.ADMUKEY]}
                        data-for={geo.properties.OBJECTID}
                        geography={geo}
                        style={{
                          default: {
                            fill: (currentData[geo.properties.ADMUKEY] !== undefined && currentData[geo.properties.ADMUKEY] !== 0)
                              ? this.state.colorScale(currentData[geo.properties.ADMUKEY])
                              : "rgba(128,128,128,0.5)",
                            stroke: "rgba(64,64,64,0.1)",
                            //stroke: "rgba(0,0,0,0.1)",
                            strokeWidth: 1.25,
                            outline: "none",

                          },
                          hover: {
                            fill: (currentData[geo.properties.ADMUKEY] !== undefined && currentData[geo.properties.ADMUKEY] !== 0)
                              ? this.state.colorScale(currentData[geo.properties.ADMUKEY])
                              : "#ddd",
                            stroke: "#607D8B",
                            strokeWidth: 0.75,
                            outline: "none",
                          },
                          pressed: {
                            fill: "#666",
                            stroke: "none",
                            outline: "none",
                          },
                        }}

                      />
                    )}
                  </Geographies>

                </ZoomableGroup>
              </ComposableMap>
              {
                (!isIE || !this.props.isPlaying) && this.props.wallonie.objects.RW_Communes.geometries.map(function (geography) {
                  const municipalityId = geography.properties.OBJECTID
                  //const recordID = (String)(geography.properties.OBJECTID)
                  let municipalityName
                  const productionLastHour = currentData[geography.properties.ADMUKEY]
                  const dayProduction = dayProductions[geography.properties.ADMUKEY]
                  const uncutDayProduction = uncutDayProductions[geography.properties.ADMUKEY]
                  const installedCapacity = installedCapacities[geography.properties.ADMUKEY]
                  const co2Avoided = co2AvoidedFactor * dayProductions[geography.properties.ADMUKEY]

                  switch (lang) {
                    case "de":
                      municipalityName = geography.properties.NAMEGER
                      break
                    case "en":
                      municipalityName = geography.properties.NAMEFRE
                      break
                    case "fr":
                    default:
                      municipalityName = geography.properties.NAMEFRE
                  }

                  return (
                    /*  
                      <ReactTooltip id={recordID} key={recordID} className={classes.toolTip + ' bgmediumgrey'}>
                    */
                    <ToolTip
                      key={"#municipality_" + municipalityId}
                      active={isTooltipActive[municipalityId]}
                      position="top" arrow="left"
                      tooltipTimeout={0}
                      parent={"#municipality_" + municipalityId}
                      style={tooltipStyle}
                      useHover={false}
                      className={classes.toolTip + ' bgmediumgrey'}
                    >
                      <div className={classes.tooltipCloseRow}>
                        <span className={classes.tooltipCloseButton} onClick={removeTooltips}>&#10006;</span>
                      </div>
                      <table style={{minWidth: '300px'}}>
                        <tbody>
                        <tr>
                          <td className={classes.leftTableColumn + ' ' + classes.tableHeader}>{municipalityLabel}</td>
                          <td className={classes.rightTableColumn + ' ' + classes.tableHeader}>{municipalityName}</td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>{renewableEnergy}</td>
                          <td className={classes.rightTableColumn}></td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>{
                            currentMode === 'realtime' ?
                              (perHour + ' (' + unitHour + ')')
                              :
                              (perMonth + ' (' + unitMonth + ')')
                          }
                          </td>
                          <td className={classes.rightTableColumn}>

                            {
                              isNaN(productionLastHour) ? "0" : (
                                currentMode === 'realtime' ? (
                                    currentFilter === 'inhabitants' ? (
                                        productionLastHour * 10
                                      ).toLocaleString(localeOption, {minimumFractionDigits: 2, maximumFractionDigits: 2}) // factor 1000 for going from kWh to Wh
                                      :
                                      Math.round(productionLastHour).toLocaleString(localeOption)
                                  )
                                  :
                                  (
                                    currentFilter === 'inhabitants' ?
                                      (Math.floor(productionLastHour / 10) / 10).toLocaleString(localeOption) :
                                      (Math.floor(productionLastHour / 100) / 10).toLocaleString(localeOption)
                                  )
                              )
                            }
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>
                            {currentMode === 'realtime' ?
                              (hasForecast ?
                                  (predictedForDay + ' (' + unitHour + ")")
                                  : (perDay + ' (' + unitHour + ")")
                              )
                              :
                              (hasForecast ?
                                  (predictedForYear + ' (' + unitMonth + ")")
                                  : (perYear + ' (' + unitMonth + ")")
                              )
                            }
                          </td>
                          <td className={classes.rightTableColumn}>
                            {isNaN(dayProduction) ?
                              "0" :
                              (currentMode === 'realtime' ?
                                  (currentFilter === 'inhabitants' ?
                                      (dayProduction * 10).toLocaleString(localeOption, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      }) // factor 1000 for going from kWh to Wh
                                      : Math.round(dayProduction).toLocaleString(localeOption)
                                  )
                                  :
                                  (currentFilter === 'inhabitants' ?
                                      (Math.floor(dayProduction / 10) / 10).toLocaleString(localeOption) :
                                      (Math.floor(dayProduction / 100) / 10).toLocaleString(localeOption)
                                  )
                              )
                            }

                          </td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>{familiesProvidedLabel}</td>
                          <td
                            className={classes.rightTableColumn}>{isNaN(uncutDayProduction) ? "0" : Math.round(uncutDayProduction / energyUsePerFamily).toLocaleString(localeOption)}</td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>{powerLabel}</td>
                          <td
                            className={classes.rightTableColumn}>{isNaN(installedCapacity) ? "0" : (Math.round(10 * installedCapacity) / 10).toLocaleString(localeOption)}</td>
                        </tr>
                        <tr>
                          <td className={classes.leftTableColumn}>{co2AvoidedLabel}</td>
                          <td
                            className={classes.rightTableColumn}>{isNaN(co2Avoided) ? "0" : (Math.round(co2Avoided / 1000).toLocaleString(localeOption))}</td>
                        </tr>
                        </tbody>
                      </table>
                    </ToolTip>
                    /*    
                      </ReactTooltip>
                    */
                  )
                })
              }
            </div>
            : <CircularProgress size={50} />
          )
        }
      </div>
    )
  }
}
EnergyMapWallonie.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(EnergyMapWallonie)
